module.exports = __webpack_public_path__ + "img/products-02.944f1ae6.jpg";